import { Component, input } from '@angular/core';
import { Address, LegalEntityWithRole } from '@app/models/project.models';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';

@Component({
  selector: 'app-special-entity-contacts',
  imports: [LabeledContentComponent],
  templateUrl: './special-entity-contacts.component.html',
  styleUrl: './special-entity-contacts.component.scss',
})
export class SpecialEntityContactsComponent {
  specialEntityContact = input.required<LegalEntityWithRole>();

  protected getAddress(address: Address): string {
    return `${address.publicSpace} ${address.publicSpaceType} ${address.houseNumber} ${address.doorOrFloor}`;
  }
}
